<div class="info-box" [ngClass]="'info-box--' + type">
  <img *ngIf="icon" class="info-box-icon" [src]="icon" alt="Icon" />
  <div class="info-box-content">
    <ng-content></ng-content>
  </div>
</div>
